import React from 'react'

import { ChristmasDeadlineInfo } from '/react4xp/parts/christmas/christmas-deadline-info'

export default (props) => <ChristmasDeadlineInfo {...props} />
